<template>
  <section>
    <v-dialog
      v-model="dialog"
      width="420px">
      <div class="dialog-container">
        <div class="plan-header">
          <div class="info flex">
            <h3>Update Status</h3>
            <i
              class="el-icon-close"
              @click="handleCancel"></i>
          </div>
        </div>
        <div class="dialog-body">
          <el-form
            ref="form"
            :model="formData"
            :rules="rules">
            <el-form-item
              prop="status"
              :rules="rules.select">
              <div
                class="box"
                :class="{'checked':formData.status==2}">
                <el-radio
                  v-model="formData.status"
                  :label="2"
                  @change="hanldeRaido">
                  <span class="span-status green">
                    Published
                  </span>
                </el-radio>
              </div>
              <div
                class="box"
                :class="{'checked':formData.status==3}">
                <el-radio
                  v-model="formData.status"
                  :label="3"
                  @change="hanldeRaido">
                  <span class="span-status blue">
                    Hidden
                  </span>
                </el-radio>
              </div>
              <div
                class="box"
                :class="{'checked':formData.status==4}">
                <el-radio
                  v-model="formData.status"
                  :label="4"
                  @change="hanldeRaido">
                  <span class="span-status dark">
                    Declined
                  </span>
                </el-radio>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="dialog-footer">
          <v-button
            gray
            @click="handleCancel">Cancel</v-button>
          <div>
            <v-button
              green
              @click="onContinue(1)">Confirm</v-button>
          </div>
        </div>
      </div>

    </v-dialog>
    <send-email-sms
      ref="send-email-sms"
      :form="customer_profile"
      :is-edit="true"
      :initContent="initContent"
      :emailListTitle="emailListTitle"
      :emailTitle="emailTitle"
      updateContent
      @skip="handlerSkip"
      @send="handlerSend" />
  </section>
</template>
<script>
import MixinRules from '@/mixins/rules'
import {updateCarbombStatus} from '@/api/car-bomb'
import SendEmailSms from '@/views/components/dialogs/send-email-sms'

export default {
  name: 'CarbombUpdateDialog',
  components:{
    SendEmailSms
  },
  mixins: [MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    id: {
      type: [String, Number],
      default: ''
    },
    value:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      dialog: false,
      formData:{
        status:'',
        // quotation_number:'',
        // desc:''
      }
    }
  },
  computed:{
    customer_profile(){
      let customer_profile = this.form.customer_profile||{}
      let {isrd_lst_nm,isrd_fst_nm,isrd_nm,nick_name} =customer_profile||{}
      if(!isrd_nm) {
        customer_profile.isrd_lst_nm = isrd_lst_nm
        customer_profile.isrd_fst_nm = isrd_fst_nm
      }
      if(nick_name){
        customer_profile.isrd_nm = nick_name
      }
      return customer_profile
    },
    emailListTitle(){
      let {success_upgraded_list_title}  = this.form||{}
      return success_upgraded_list_title
    },
    emailTitle(){
      let {success_upgraded_title}  = this.form||{}
      return success_upgraded_title
    },
    initContent(){
      let {status} = this.formData
      let {set_giveaway='',set_declined=''}  = this.form||{}
      return status==2?set_giveaway:set_declined
    },

  },
  watch: {
    value:{
      immediate: true,
      handler(val){
        this.dialog = val
      }
    },
  },
  methods: {
    handlerSkip(){
      let params ={
        content:'',
        is_send:0
      }
      this.network().updateCarbombStatus(params)
    },
    handlerSend(content){
      let params ={
        content:content,
        is_send:1
      }
      this.network().updateCarbombStatus(params)
    },
    hanldeRaido(){
      let {status} = this.formData||{}
      // if(status!=1){
      //   this.formData.quotation_number = ''
      // }
      this.$refs.form.clearValidate(['status'])
    },
    handleCancel(){
      this.dialog = false
      this.formData.status = ''
      this.$refs['form'].resetFields()
      this.$emit('input',this.dialog)
    },
    onContinue(settle_id) {
      this.$refs.form.validate( (valid) => {
        if (valid) {
          // 額外參數
          let {status} = this.formData||{}
          this.network().updateCarbombStatus()

        }

      })

    },
    network() {
      return {
        updateCarbombStatus: async (params) => {
          let id = this.$route.params.id
          params = {
            id: id,
            ...this.formData,
            ...params
          }

          const { data } = await updateCarbombStatus(params)
          this.dialog = false
          this.formData.status = ''
          this.$emit('input',this.dialog)
          this.$emit('refresh')

        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
  //padding: 15px;
  .plan-header {
    //padding: 15px;
    background: #F6F8FA;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    .info{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding:16px;
      font-size: 14px;
      font-weight: 600;
      color: #24292E;
      border-bottom: 1px solid #E1E4E8;
      i{
        font-weight: 600;
        font-size: 14px;
      }
      h3{
        padding-bottom: 0;
        font-size: 14px;
        font-weight: 600;
        color: #24292E;
      }
    }
  }
  .dialog-footer {
    //margin: 15px -15px -15px;
    display: flex;
    justify-content: space-between;
    padding: 15px;
    text-align: right;
    //background: #F9FAFB;
  }

  .dialog-body{
    padding: 15px;
    .box{
      border-radius: 6px;
      padding: 20px;
      border: 1px solid #D1D5DA;
      background: #FFF;
      margin-bottom: 16px;
      &:last-child{
        margin-bottom: 0;
      }
      &.checked{
        border: 1px solid #0366D6;
      }
      .form-item{
        padding-bottom: 0;
      }
      .give-away-text{
        color: #586069;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px;
      }
    }
    .mg-t-16{
      margin-top: 16px;
    }
    .span-status {
      display: inline-block;
      margin-right: 15px;
      padding: 5px 10px;
      border-radius: 12px;
      font-size: 12px;
      line-height: 14px;
      color: white;
      font-weight: 500;
      .svg-inline--fa {
        margin-right: 5px;
        font-size: 14px;
      }
      &.green {
        background: #28a745;
        color: white;
      }
      &.orange {
        background: #E36209;
        color: white;
      }
      &.yellow-dark {
        background: #DBAB09;
      }
      &.blue {
        background: #0366D6;
      }
      &.dark {
        background: #444D56;
      }
      &.min-green {
        background: #dcffe4;
        color: #28a745;
      }
    }
  }
}
</style>
